import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Store } from '../index';
import { ToggleModel } from '../../../utils/pageUtils';
import Slider from 'react-slick';
import '../resources/carousel-slick/slick.css';
import '../resources/carousel-slick/slick-theme.css';

// import { Marquee } from './parts/Marquee';
// import marquee from 'jquery.marquee';

import '../resources/custom.css';

const drbillur = require('../resources/drbillur.jpg');
const drruhulamin = require('../resources/drruhulamin.jpg');
const drmohiuddin = require('../resources/mohiuddin.jpg');
const drlita = require('../resources/lita.jpg');
const venueCarouselPic = require('../resources/venue_carousel_landing.png');
const vacationCarouselPic = require('../resources/vacation_carousel_landing.png');
const speakersCarouselPic1 = require('../resources/speakers_carousel_landing_1.png');
const speakersCarouselPic2 = require('../resources/speakers_carousel_landing_2.png');
const accomodationCarouselPic = require('../resources/accomodation_carousel_landing.png');
const atnBanglaLogo = require('../resources/atn_bangla.jpg');

const CarouselImages = [
  venueCarouselPic,
  vacationCarouselPic,
  speakersCarouselPic1,
  speakersCarouselPic2,
  accomodationCarouselPic
];
const DefaultSlider = ( props: {
  infinite: boolean,
  slidesToShow: number,
  slidesToScroll: number,
  autoplay: boolean,
  autoplaySpeed: number,
  accessibility: boolean,
  images: string[]
}) => (
  <Slider
    infinite={props.infinite}
    slidesToShow={props.slidesToShow}
    slidesToScroll={props.slidesToScroll}
    autoplay={props.autoplay}
    autoplaySpeed={props.autoplaySpeed}
    accessibility={props.accessibility}
    arrows={1}
    dots={true}
    adaptiveHeight={true}
    fade={true}
    cssEase="linear"
  >
    {props.images.map( (image) => (
      <img src={image} alt="banner-offer" />
    ))}
  </Slider>
);

const LandingPageComponent = observer((
  props: {
    store?: typeof Store.Type,
    registrationToggle: typeof ToggleModel.Type
  }
) => (
    <div>
      <p className="news_marquee nowrap overflow-hidden ma0">
        <span className="b f5 pv2 dib">
          Limited number of rooms at the Venue - Book your accommodation now
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Online registration going on
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Take a look at our experienced keynote speakers
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Thanks to our sponsors
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Sponsor list: Square Pharmaceuticals, Incepta Pharmaceuticals, Beximco Pharmaceuticals, Mediplus, 
          ACI Pharmaceuticals, Ziska Pharmaceuticals, Opsonin Pharmaceuticals, Renata Pharmaceuticals, 
          Unimed {'&'} Unihealth, Jayson Pharmaceuticals, Drug International, Alok Pharmaceuticals
        </span>
      </p>
      {/* <div className="marquee" data-duplicated="true">
        <span>Longer text lorem ipsum dolor sit amet, consectetur adipiscing elit END.</span>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>shah arfan mahdi</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>sadman soeb</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div> */}
      {/* <Marquee
        text={
          <span>
            <span className="b pr4 f4 mv">
              Limited number of rooms at the Venue - Book your accommodation now
          </span>
            <span className="b pr4 f4 mv">
              Online registration going on
          </span>
            <span className="b pr4 f4 mv">
              Take a look at our experienced keynote speakers
          </span>
            <span className="b pr4 f4 mv2 pl3">
              Thanks to our sponsors
          </span>
          </span>
        }
      /> */}
      <div className="w-100 overflow-hidden center">
        <DefaultSlider
          infinite={true}
          slidesToShow={1}
          slidesToScroll={1}
          autoplay={true}
          autoplaySpeed={2000}
          accessibility={true}
          images={CarouselImages}
        />
      </div>
      <div className=" w-100 fl white" style={{ backgroundColor: '#b45f06' }}>
        <div className="mw9 center dt">
          <div className="fl w-100 w-70-l pa2">
            <p className="f6 f3-l b">INVITATION</p>
            <p className="f6 f4-l">Dear Colleagues,</p>
            <p className="f6 f5-ns mb4">It is a great pleasure for us to invite you to be a part of the 5th national and 2nd international Bangladesh Congress on oral and maxillofacial surgery, (BCOMS) to be held in Bangabandhu International Conference Center (BICC) at 20th January,2018. The pre-conference workshop is going to be held in Bangabandhu Sheikh Mujib Medical University (BSMMU) at 19th January, 2018. The program is carried out with national and international organizations of various countries.</p>
            <p className="f6 f5-ns mb4">Along with the scientific program the organizing committee has put together several cultural programs and site-seeing tours. Dhaka, the host city of the conference offers temperate weather and the natural beauty. The Sixty Dome Mosque (more commonly known as Shait Gambuj Mosque or Saith Gunbad Masjid) is the largest historical mosque in Bangladesh and one of the most impressive Muslim architectural structures on the Indian Subcontinent</p>
            <p className="f6 f5-ns mb4">Cox’s Bazar, the world’s longest natural sandy sea beach with its incredible 125 km length, and most visited tourist destinations in Bangladesh. Cox’s Bazar is really a great place to visit for a tourist. Every year a huge number of tourists come here from across the world. Most beautiful place in Bangladesh.</p>
            <p className="f6 f5-ns mb4">We invite you to participate in the BCOMS 2018 and exchange your expertise with more than 1,000 specialists in the field of oral and maxillofacial surgery.</p>
          </div>
          <div className="fl w-100 w-30-l pa2 mt4">
            <div className="pa2 black" style={{ backgroundColor: 'rgba(181, 172, 172, 0.75)' }}>
              <p className="f6 f3-l tc b bb bw1">NEWS AND UPDATES</p>
              <ul className="f5">
                <li className="mv3">Last Date of Registration: <br /> 15 <sup style={{left: '-4px'}}>th</sup> December 2017</li>
                <li className="mv3">Pre-Conference workshop: <br /> 19 <sup style={{left: '-4px'}}>th</sup> January 2018</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mw9 center">
          <div className="fl w-100 pa2 pb2-ns pb0">
            <p className="f3-ns f5 b tc pt5-ns pt0">Conference Committee</p>
          </div>
          <div className="fl w-100 w-25-ns pa2">
            <article className="w-100 pa3">
              <p className="tc"><img src={drruhulamin} alt="Doctor pic" className="w-40" /></p>
              <p className="f5-ns f6 b tc mb0">Prof. Dr. Md. Ruhul Amin</p>
              <p className="f6 mb0 tc">Head of the Department of Oral and Maxillofacial Surgery</p>
              <p className="f6 tc mb0">Dhaka Medical College and Hospital</p>
              <p className="f6 tc">President, BAMOS</p>
            </article>
          </div>
          <div className="fl w-100 w-25-ns pa2">
            <article className="w-100 pv3 ph0">
              <p className="tc"><img src={drbillur} alt="Doctor pic" className="w-30" /></p>
              <p className="f5-ns f6 b tc mb0">Prof. Dr. Quazi Billur Rahman</p>
              <p className="f6 mb0 tc">Chairman</p>
              <p className="f6 tc mb0">Department of Oral and Maxillofacial Surgery </p>
              <p className="f6 tc mb0">Bangabandhu Sheikh Mujib Medical University</p>
              <p className="f6 tc">Secretary General, BAMOS</p>
            </article>
          </div>
          <div className="fl w-100 w-25-ns pa2">
            <article className="w-100 pa3">
              <p className="tc"><img src={drmohiuddin} alt="Doctor pic" style={{width: '35%'}} /></p>
              <p className="f5-ns f6 b tc mb0">Prof. Dr. Mohiuddin Ahmed</p>
              <p className="f6 mb0 tc">Principal</p>
              <p className="f6 tc mb0">Sapporo Dental College and Hospital</p>
              <p className="f6 tc mb0">Chairman, BCOMS 2018</p>
            </article>
          </div>
          <div className="fl w-100 w-25-ns pa2">
            <article className="w-100 pa3">
              <p className="tc"><img src={drlita} alt="Doctor pic" style={{width: '35%'}} /></p>
              <p className="f5-ns f6 b tc mb0">Prof. Dr. Ismat Ara Haider Lita</p>
              <p className="f6 mb0 tc">Head of the Department of Oral and Maxillofacial Surgery</p>
              <p className="f6 tc mb0">Dhaka Dental College and Hospital</p>
              <p className="f6  tc mb0">Secretary, BCOMS 2018</p>
            </article>
          </div>
        </div>
      </div>
      <div className="fl w-100">
        <p className="f5 f3-ns pa3 tc">Media Partner: 
          <span className="v-mid"><img src={atnBanglaLogo} alt="ATN Bangla Logo" /></span>
          <span className="b"> ATN  Bangla Limited</span>
        </p>
      </div>
    </div>
  ));

export const LandingPage = inject('store')(observer((props: { store?: typeof Store.Type }) => {
  const registrationToggle = ToggleModel.create();
  return <LandingPageComponent store={props.store} registrationToggle={registrationToggle} />;
}));


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/pages/Landing.tsx